/**
 * Centralized pricing examples + framing copy.
 *
 * RULE: all numbers and disclaimer language live here. Pages import from
 * this single source so we never drift, and a single edit propagates.
 *
 * IMPORTANT: All numbers are framed as TYPICAL/ESTIMATED, never guaranteed.
 * Forbidden words anywhere this is rendered: `final`, `exact`, `order-ready`,
 * `guaranteed`. Compose using the helpers below to stay safe.
 */

export const TIERS = [
  {
    id: 'good',
    label: 'Good',
    brand: 'ECO Windows',
    logo:
      'https://customer-assets.emergentagent.com/job_impact-quote-hub/artifacts/w9jekft2_eco_window_systems_logo%20%281%29.jpg',
    blurb: 'Reliable impact protection from a locally manufactured option.',
  },
  {
    id: 'better',
    label: 'Better',
    brand: 'Mr. Glass',
    logo:
      'https://customer-assets.emergentagent.com/job_impact-quote-hub/artifacts/1edhksrg_Mr-Glass-Logo.png',
    blurb: 'Refined frames and upgraded glass options for most South Florida homes.',
  },
  {
    id: 'premium',
    label: 'Premium',
    brand: 'ES Windows',
    logo:
      'https://customer-assets.emergentagent.com/job_impact-quote-hub/artifacts/dt288m9t_ESWindow-Logo_Web.png',
    blurb: 'Premium design pressure ratings and architectural finishes.',
  },
];

/**
 * Three published price example rows. Numbers come straight from the
 * existing homepage FAQ — do NOT introduce new claims here.
 */
export const PRICE_EXAMPLES = [
  {
    id: 'window-37x51',
    label: 'Standard 37" × 51" impact window, installed',
    rows: [
      { tier: 'ECO', amount: '~$930' },
      { tier: 'Mr. Glass', amount: '~$960' },
      { tier: 'ES Windows', amount: '~$1,003' },
    ],
  },
  {
    id: 'sgd-72x80',
    label: '72" × 80" sliding glass door, installed',
    rows: [
      { tier: 'ECO', amount: '~$2,500' },
      { tier: 'Mr. Glass', amount: '~$2,800' },
      { tier: 'ES Windows', amount: '~$3,100' },
    ],
  },
  {
    id: 'full-home',
    label: 'Typical full-home project',
    rows: [{ tier: 'Range', amount: '$15,000 – $40,000+' }],
  },
];

export const PRICING_FRAME_COPY =
  'Pricing depends on opening size, product tier, glass type, access, permit requirements, and installation complexity. The numbers below are typical estimates — your installed price is confirmed before ordering.';

export const PRICING_DISCLAIMER_SHORT =
  'Typical estimates only. Confirmed before ordering.';
